"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccessRole = exports.useCurrentTime = exports.useIsPluginEnabled = void 0;
const useIsPluginEnabled_1 = require("./useIsPluginEnabled");
Object.defineProperty(exports, "useIsPluginEnabled", { enumerable: true, get: function () { return useIsPluginEnabled_1.useIsPluginEnabled; } });
const useCurrentTime_1 = require("./useCurrentTime");
Object.defineProperty(exports, "useCurrentTime", { enumerable: true, get: function () { return useCurrentTime_1.useCurrentTime; } });
const useAccessRole_1 = require("./useAccessRole");
Object.defineProperty(exports, "useAccessRole", { enumerable: true, get: function () { return useAccessRole_1.useAccessRole; } });
